import React, { useState } from "react";
import styles from "./productandSupply.module.css";
import { useNavigate } from "react-router-dom";
import construction from "../../Assests/Images/construction.png";
import construction1 from "../../Assests/Images/animation-and-switch-gear.png";
import construction2 from "../../Assests/Images/cable-accessories.png";
import construction3 from "../../Assests/Images/drives-transmission.png";
import construction4 from "../../Assests/Images/pump.png";
import construction5 from "../../Assests/Images/laboratry-cleanroom.png";
import construction6 from "../../Assests/Images/hydraulic.png";
import construction7 from "../../Assests/Images/valves.png";
import construction8 from "../../Assests/Images/electric-items.png";
import construction9 from "../../Assests/Images/mechanical-part.png";
import construction10 from "../../Assests/Images/cleaning-hygenic.png";
import construction11 from "../../Assests/Images/safety-pre.png";
import construction12 from "../../Assests/Images/chemical-technical.png";
import construction13 from "../../Assests/Images/medical-relief.png";
import construction14 from "../../Assests/Images/cran-loading.png";
import whitecrossicon from "../../Assests/Images/close-normal.svg";
import bluecrossicon from "../../Assests/Images/close-hover.svg";

const productCategories = [
  {
    image: construction1, 
    title: "Automation & Switchgear",
    description: "Reliable control and power solutions for industrial and hazardous environments."
  },
  {
    image: construction2, 
    title: "Cables & Accessories",
    description: "Durable cabling systems for data, control, and power transmission."
  },
  {
    image: construction3, 
    title: "Drives & Transmission Spares",
    description: "Precision components for motion control and power transfer."
  },
  {
    image: construction4, 
    title: "Instrumentation & Pumps",
    description: "Measurement, dosing, and fluid control equipment for process systems."
  },
  {
    image: construction5, 
    title: "Laboratory & Cleanroom Equipment",
    description: "Certified equipment for quality control, testing, and cleanroom environments."
  },
  {
    image: construction6, 
    title: "Pneumatic & Hydraulic Systems",
    description: "High-performance fluid power components for industrial use."
  },
  {
    image: construction7, 
    title: "Valves & Actuation",
    description: "Precision control for fluid, gas, and slurry systems."
  },
  {
    image: construction8, 
    title: "Electrical Items",
    description: "Complete electrical supply for industrial and hazardous areas."
  },
  {
    image: construction9, 
    title: "Mechanical Parts & Components",
    description: "Spare parts and assemblies for heavy equipment and production lines."
  },
  {
    image: construction10, 
    title: "Cleaning, Hygiene & Environmental Systems",
    description: "Solutions for site hygiene, environmental safety, and sanitation."
  },
  {
    image: construction11, 
    title: "Safety & PPE",
    description: "Critical protection for personnel and high-risk operations."
  },
  {
    image: construction12, 
    title: "Chemicals & Technical Fluids",
    description: "Specialist fluids and treatments for industrial performance and maintenance."
  },
  {
    image: construction13, 
    title: "Humanitarian, Medical & Relief Supplies",
    description: "Deployable infrastructure and essentials for field and crisis operations."
  }
];

const productDetails = {
  "Automation & Switchgear": [
    "Panel meters, cam switches, contactors",
    "PLCs, HMIs, motor starters, control gear",
    "Monitoring relays, overload relays, timers",
    "Manual motor starters, push-button stations",
    "Process controllers, signal converters",
    "Stainless steel and polycarbonate enclosures",
    "Switches, limiters, hazardous area control gear",
  ],
  "Cables & Accessories": [
    "LV and MV cables (PVC, XLPE, LSF, armoured)",
    "Instrumentation, coaxial and signal cables",
    "Cable glands, heat shrink kits, lugs",
    "Cable marking, termination kits",
    "Trunking, conduits, ties and accessories",
  ],
  "Drives & Transmission Spares": [
    "Variable frequency drives (VFDs)",
    "Motors, pulleys, bushes, belts",
    "Gearboxes, couplings, actuators",
  ],
  "Instrumentation & Pumps": [
    "Flow meters, pressure sensors, level gauges",
    "Transmitters, recorders, controllers",
    "Dosing pumps – diaphragm, peristaltic, solenoid",
    "Vacuum systems and filtration assemblies",
  ],
  "Laboratory & Cleanroom Equipment": [
    "Analytical balances, weighing and pH meters",
    "Centrifuges, stirrers, thermal control devices",
    "Lab glassware, consumables, filter media",
    "Cleanroom garments, gloves, wipes",
    "Monitoring and calibration kits",
  ],
  "Pneumatic & Hydraulic Systems": [
    "Hydraulic pumps, hoses, valves, actuators",
    "Pneumatic fittings, cylinders, regulators",
    "Manifolds, boosters, filtration systems",
    "Quick-release and high-pressure connectors",
  ],
  "Valves & Actuation": [
    "Ball, gate, knife gate, diaphragm, butterfly valves",
    "Electric, pneumatic and solenoid actuators",
    "Control valves, positioners, limit switches",
    "Non-return, relief and safety valves",
  ],
  "Electrical Items": [
    "Floodlights, LED, explosion-proof and emergency lighting",
    "Plugs, sockets, and panel accessories",
    "MCBs, fuses, transformers, surge protectors",
    "Fans, HVAC components, water heating elements",
    "Wiring systems, cable routing products",
    "Testing tools: multimeters, clamp meters, insulation testers",
  ],
  "Mechanical Parts & Components": [
    "Conveyor belts, rollers, support systems",
    "Bearings, seals, gears, fasteners",
    "Gaskets, fabrication kits, wear parts",
    "Shock absorbers, vibration mounts, component hardware",
  ],
  "Cleaning, Hygiene & Environmental Systems": [
    "Industrial vacuums, floor scrubbers",
    "Spill control kits, hygiene stations",
    "Degreasers, disinfectants, cleaning agents",
    "Sanitary ware, paper dispensers, janitorial supplies",
  ],
  "Safety & PPE": [
    "FR and high-visibility workwear",
    "Helmets, gloves, safety boots, goggles",
    "Gas detection, fire extinguishers, eyewash units",
    "Confined space kits, emergency response tools",
    "Safety signage, barriers, lockout systems",
  ],
  "Chemicals & Technical Fluids": [
    "Fuel additives, combustion improvers",
    "Anti-foam agents, corrosion inhibitors",
    "Greases, hydraulic fluids, industrial solvents",
    "Water treatment chemicals and cleaning formulations",
  ],
  "Humanitarian, Medical & Relief Supplies": [
    "Emergency tents, shelters, camp beds",
    "Mobile toilets, water purification, WASH kits",
    "First aid kits, diagnostics, portable power units",
    "Solar lighting, food kits, field logistics support",
  ],
};

function ProductandSupply() {
  const navigate = useNavigate();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleContactClick = () => {
    navigate("/contact");
  };
  
  const handleProductClick = (product) => {
    setSelectedProduct(product);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedProduct(null);
  };

  return (
    <>
      <div className={styles.globalTechOverviewSection}>
        <div>
          <div className={styles.globalTechOverlay}>
            <div className={styles.overlaySection}>
              <div className={styles.globalTeamContent}>
                <img src={construction} alt="Global Team" className={styles.globalTeamImage} />
              </div>
              <div className={styles.globalTechText}>
                <h1 className={styles.heading}>
                  Trusted Equipment. Global Reach. Industry Focused Supply.
                </h1>
                <div className={styles.globalTechDescription}>
                  Our team of experts combines years of experience in
                  procurement, logistics, and supply chain management. Led by
                  industry professionals, we bring a solutions-driven approach
                  to every client engagement
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.section2}>
        <div className={styles.header2}>
          <div className={styles.heading2}>Explore our core product categories</div>
        </div>
        <p className={styles.ourAgentDescription}>
          These categories represent just a sample of what we supply. Our team can support custom sourcing,
          specification matching, and full procurement support across a much broader range.
        </p>
      </div>

      <div className={styles.productGridSection}>
        <div className={styles.productGrid}>
          {productCategories.map((item, index) => {
            let gridColumnClass = '';
            
            if (productCategories.length % 3 === 1 && index === productCategories.length - 1) {
              gridColumnClass = styles.centerColumnOnly;
            }
            
            if (productCategories.length % 3 === 2) {
              if (index === productCategories.length - 2) {
                gridColumnClass = styles.leftColumnOfTwo;
              } else if (index === productCategories.length - 1) {
                gridColumnClass = styles.rightColumnOfTwo;
              }
            }
            
            return (
              <div 
                key={index} 
                className={`${styles.productItem} ${gridColumnClass}`}
                style={{ backgroundImage: `url(${item.image})` }}
                onClick={() => handleProductClick(item)}
              >
                <div className={styles.productOverlay}>
                  <div className={styles.productContent}>
                    <div className={styles.productTitle}>{item.title}</div>
                    {item.description && (
                      <div className={styles.productDescription}>
                        {item.description}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div 
        className={styles.section3}
        style={{ 
          backgroundImage: `url(${construction14})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className={styles.section3Overlay}>
          <div className={styles.section3Content}>
            <p className={styles.section3Description}>
              We deliver only certified, industry approved products trusted by clients worldwide 
              to support safe, efficient, and mission critical operations.
            </p>
            
            <h4 className={styles.section3Heading}>
              Need a Custom Solution?
            </h4>
            
            <p className={styles.section3text}>
              We specialise in urgent sourcing, complex logistics, and project based procurement delivering to remote, 
              post disaster, or conflict affected regions with full regulatory compliance.
            </p>
            
            <p className={styles.section3Description}>
              Let Hyproc International be your procurement partner wherever your mission takes you.
            </p>
          </div>
          {/* <button 
            onClick={handleContactClick} 
            className={styles.contactButton}
          >
            <span className={styles.contactButtonText}>
              Contact us
            </span>
          </button> */}
             <button  onClick={handleContactClick}  className={styles.newbutton}>
               Contact us
          </button>
        </div>
      </div>
      {showModal && selectedProduct && (
  <div className={styles.modalOverlay} onClick={closeModal}>
    <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
      <div className={styles.modalHeader}>
        <h2 className={styles.modalTitle}>{selectedProduct.title}</h2>
        <button className={styles.closeButton} onClick={closeModal}>
          <img 
            src={whitecrossicon} 
            alt="Close" 
            className={styles.closeIconWhite} 
          />
          <img 
            src={bluecrossicon} 
            alt="Close" 
            className={styles.closeIconBlue} 
          />
        </button>
      </div>
      
      <ul className={styles.modalBulletList}>
        {productDetails[selectedProduct.title]?.map((detail, index) => (
          <li key={index}>{detail}</li>
        ))}
      </ul>
    </div>
  </div>
)}
    </>
  );
}

export default ProductandSupply;